// true if user has interacted with all the fields
const isFormValid = ( dirtyObj: any ) =>
    Object.values( dirtyObj ).reduce(
        ( acc, currentValue ) => acc && currentValue,
        true,
    );

const findError = ( formErrors: any ) =>
    Object.values( formErrors ).filter( value => value );

const validateInput = ( val: any, regex: any, required: any, valid: any ) => {
    let errorValue;
    if( !val ) {
        errorValue = required;
    }else if( valid && regex && !regex.test( val ) ) {
        errorValue = valid;
    }
    return errorValue;
};

const validateForm = ( values: any, dirtyObj: any) => {
    const formErrors: Record<string, string> = {};
    const keyArr = Object.keys( values );
    let errorStatus = true;

    for( const key of keyArr ) {
        const inputValue = values[ key ];
        if( dirtyObj[ key ] ) {
            switch ( key ) {
            case 'legalEntityName':
                formErrors[ key as keyof typeof formErrors] = validateInput(
                    inputValue,
                    null,
                    'Please enter legal entity name.',
                    ''
                );
                break;
            default:
                break;
            }
        }
    }

    if( isFormValid( dirtyObj ) ) {
        errorStatus = !!findError( formErrors ).length;
    }

    return { formErrors, errorStatus };
};

export default validateForm;
